import script from "./ExcelSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcelSplit.vue?vue&type=script&setup=true&lang=js"

import "./ExcelSplit.vue?vue&type=style&index=0&id=ec888302&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec888302"]])

export default __exports__